// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgImageIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M19 4.13H5c-1.65 0-3 1.35-3 3v10c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3v-10c0-1.65-1.35-3-3-3m-4 14H4l5.5-7 3.71 4.72 2.04-2.72 3.75 5zm3-8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2" />
  </g>
);
export default SvgImageIcon;
SvgImageIcon.displayName = 'SvgImageIcon';
